import React from 'react';
import { Comment } from 'types/comment';
import styles from './CommentContents.module.css';
import { renderReactElements } from './editor/Renderer';

type Props = {
  comment: Comment;
};

export default function CommentContents(props: Props) {
  const showDeleted = props.comment.isDeleted;
  const showHidden = props.comment.isHidden && !showDeleted;
  const showContent = !showHidden && !showDeleted;

  return (
    <div className={styles.CommentContents}>
      {showDeleted && <strong>[deleted]</strong>}
      {showHidden && <strong>[hidden by moderators]</strong>}
      {showContent &&
        props.comment.data.comment !== undefined &&
        renderReactElements({ children: props.comment.data.comment })}
    </div>
  );
}
